<p-table #dtId [columns]="dataColumns" [value]="data" dataKey="guid" [paginator]="true" [rows]="5" [responsive]="true"
  [resizableColumns]="true">
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th *ngFor="let col of columns" pResizableColumn [pSortableColumn]>
        {{col.name}}
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData let-columns="columns">
    <tr>
      <td *ngFor="let col of columns" class="ui-resizable-column">
        <span class="ui-column-title">{{col.name}}</span>
        <span *ngIf="col.fieldType == 1">
          {{rowData[col.shortName]}}
        </span>
        <span *ngIf="col.fieldType == 2">
          {{rowData[col.shortName]}}
        </span>
        <span *ngIf="col.fieldType == 3">
          {{rowData[col.shortName]}}
        </span>
        <span *ngIf="col.fieldType == 4">
          {{rowData[col.shortName]}}
        </span>
        <span *ngIf="col.fieldType == 5">
          {{rowData[col.shortName] | date }}
        </span>
        <span *ngIf="col.fieldType == 7">
          <button nbButton ghost size="small" status="primary" (click)="onClickListRow(rowData[col.shortName])">
            {{ 'Show' | i18next }}
          </button>
        </span>
      </td>
    </tr>
  </ng-template>
</p-table>
<!-- <nb-card [size]="'large'">
        <nb-tabset fullWidth>
          <nb-tab [tabTitle]="title">
            <div class="icon-bar">
              <div class="icon" (click)="downloadDataAsXlsx()">
                <fa-icon [icon]="['far', 'file-excel']"></fa-icon>
              </div>
            </div>
    </nb-tab>
  </nb-tabset>
</nb-card> -->

<!-- <table class="table">
  <thead>
    <tr>
      <th scope="col" *ngFor="let c of dataColumns">{{c.name}}</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let row of data">
      <td *ngFor="let c of dataColumns; let i = index">
        <span *ngIf="c.fieldType == 1">
          {{row[c.shortName]}}
        </span>
        <span *ngIf="c.fieldType == 2">
          {{row[c.shortName]}}
        </span>
        <span *ngIf="c.fieldType == 3">
          {{row[c.shortName]}}
        </span>
        <span *ngIf="c.fieldType == 4">
          {{row[c.shortName]}}
        </span>
        <span *ngIf="c.fieldType == 5">
          {{row[c.shortName] | date }}
        </span>
        <span *ngIf="c.fieldType == 7">
          <button nbButton ghost size="small" status="primary" (click)="onClickListRow(row[c.shortName])">
            {{ 'Show' | i18next }}
          </button>
        </span>
      </td>
    </tr>
  </tbody>
</table> -->